export const BUILD_VERSION: string | null = '1793876889238';
